// 直播观看
const zsxxwRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `liveStreaming/index${i + 1}`,
  name: `liveStreaming/Index${i + 1}`,
  component: () => import(`@/views/study/liveStreaming/index${i + 1}.vue`)
}))





export default {
  path: '/study',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 直播观看，开始
    ...zsxxwRoutes,
    // 直播观看，结束


  ],
};
